import { useTranslation } from 'react-i18next'

const TeacherEnvironmentStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080" 
      role="image"
      aria-labelledby="teacher-environment-start-title"
      fill="none"
      {...props}
    >
      <title id="teacher-environment-start-title">{t('antagonists:teacherEnvironment:components:start')}</title>
      <defs>
        <clipPath id="teacher-environment-a">
          <path
            d="M1415.53 971.61c-8.28 5.1-9.88 18.08-9.88 18.08s13.64 3.03 26.51 4.55c25.23 2.97 45.35-.06 58.33-.76 18.99-1.02 40.5-6.08 40.5-6.08s-2.08-7.93-2.72-20.67c-.64-12.74-5.32-23.49-5.32-23.49l-2.22.09s4.78 14.68-11.15 14.49c-21.02-.25-28.79-10.39-28.79-10.39s4.33-4.82 3.75-8.19c-.38-2.22-4.06-3.71-4.06-3.71s-13.59 10.4-20.81 17.2c-7.22 6.79-23.02 14.33-26.33 15.08-6.54 1.48-15.01 2.08-17.84 3.82Z"
            style={{
              fill: '#2a5151',
            }}
          />
        </clipPath>
        <clipPath id="teacher-environment-b">
          <path
            d="M1571.81 941.03c-6.21.34-10.62 8.92-14.44 10.83-3.82 1.91.21 8.28-.85 19.53-1.06 11.25-2.12 15.5-2.12 20.38s2.12 8.07 2.12 8.07 20.6-.21 31-.85c10.4-.64 15.08-2.12 15.08-2.12s2.12-4.03-.21-10.62c-2.34-6.58-5.73-9.55-7.22-19.32-1.49-9.77-3.61-13.59-3.61-13.59s-2.76-1.7-6.16-5.52c-3.4-3.82-5.48-7.24-13.59-6.79Z"
            style={{
              fill: '#2a5151',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1485.6 919.38s.42 10.4-3.82 17.62c-4.25 7.22-16.99 18.47-16.35 18.47s46.29 12.32 46.29 12.32l11.04-15.5s-2.97-10.19-2.55-21.02c.42-10.83 1.06-18.68 1.06-18.68l-35.67 6.79Zm78.56 6.58-5.09 31.21 29.94 7.22 2.97-4.46-3.4-26.11-24.42-7.86z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1462.86 537.39c-1.09 2.73 1.26 39.55-8.04 58.7-9.3 19.14-5.09 39.2-.71 72.01s20.78 95.16 22.42 113.21c1.64 18.05 2.19 55.24 3.83 80.4 1.64 25.16-1.09 72.74-1.09 72.74s13 6.02 25.58 6.57c12.58.55 22-3.83 22-3.83s8.2-63.44 8.75-102.27c.55-38.83-5.47-50.86-4.38-70 1.09-19.14 10.39-97.35 10.39-97.35l-6.02-127.43-72.74-2.73Z"
        style={{
          fill: '#516386',
        }}
      />
      <path
        d="M1507.71 563.64s25.16 153.13 32.27 182.67c7.11 29.53 6.8 37.81 6.8 44.77 0 8.93 4.68 15.94 6.32 35.63 1.64 19.69 3.83 115.94 3.83 115.94s9.3.55 19.69 1.64c10.39 1.09 18.59-1.64 18.59-1.64s16.95-79.85 14.22-118.13c-2.73-38.28-12.03-68.91-8.2-93.52s9.95-77.67 10.5-103.92c.55-26.25-13.24-49.21-21.44-77.1-8.2-27.89-19.14-47.03-19.14-47.03l-63.44 60.71Z"
        style={{
          fill: '#516386',
        }}
      />
      <path
        d="M1415.53 971.61c-8.28 5.1-9.88 18.08-9.88 18.08s13.64 3.03 26.51 4.55c25.23 2.97 45.35-.06 58.33-.76 18.99-1.02 40.5-6.08 40.5-6.08s-2.08-7.93-2.72-20.67c-.64-12.74-5.32-23.49-5.32-23.49l-2.22.09s4.78 14.68-11.15 14.49c-21.02-.25-28.79-10.39-28.79-10.39s4.33-4.82 3.75-8.19c-.38-2.22-4.06-3.71-4.06-3.71s-13.59 10.4-20.81 17.2c-7.22 6.79-23.02 14.33-26.33 15.08-6.54 1.48-15.01 2.08-17.84 3.82Z"
        style={{
          fill: '#2a5151',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-environment-a)',
        }}
      >
        <path
          d="M1405.34 977.34s4.46 3.96 25.05 6.72c20.6 2.76 39.07.49 55.63-.57 16.56-1.06 46.08-9.13 46.08-9.13l.21 21.66-135.47 1.7 8.49-20.38Z"
          style={{
            fill: '#e6eef8',
          }}
        />
      </g>
      <path
        d="M1571.81 941.03c-6.21.34-10.62 8.92-14.44 10.83-3.82 1.91.21 8.28-.85 19.53-1.06 11.25-2.12 15.5-2.12 20.38s2.12 8.07 2.12 8.07 20.6-.21 31-.85c10.4-.64 15.08-2.12 15.08-2.12s2.12-4.03-.21-10.62c-2.34-6.58-5.73-9.55-7.22-19.32-1.49-9.77-3.61-13.59-3.61-13.59s-2.76-1.7-6.16-5.52c-3.4-3.82-5.48-7.24-13.59-6.79Z"
        style={{
          fill: '#2a5151',
        }}
      />
      <g
        style={{
          clipPath: 'url(#teacher-environment-b)',
        }}
      >
        <path
          d="M1549.73 990.93s11.47-5.1 25.9-4.03c15.05 1.11 16.61 2.78 24.84 2.55 7.43-.21 18.26-2.55 18.26-2.55l.64 23.99-63.27-1.06-6.37-18.9Z"
          style={{
            fill: '#e6eef8',
          }}
        />
      </g>
      <path
        d="M1521.72 301.4c-25.86 6.98-51.27 8.28-54.63 9.45s.88 13.92.88 13.92l-31.14 16.44s-.67 9.99-.67 28.65v62.63l173.23 3s31.32-66.63 25.65-76.96c-5.66-10.33-35.51-24.1-45.17-32.43-9.66-8.33-7.55-25.82-9.81-27.85s-37.37-2.52-58.35 3.14Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1448.33 578.92s13.5 9.86 48.97 16.67c35.47 6.81 87.53-7.29 87.53-7.29l-10.94-268.72-37.78-14.53-46.51 14.11s-35.11 230.38-36.19 230.74c-1.07.36-5.08 29.03-5.08 29.03Z"
        style={{
          fill: '#dac941',
        }}
      />
      <path
        d="M1504.87 305.77s-14.4 40.78-18.73 80.09-3.33 127.59-4.33 152.58c-1 24.99-.78 70.17-.78 70.17s-13.5 4.97-26.59.32c-13.1-4.65-20.6-5.53-20.6-5.53s1.71-7.99.33-23.65c-1.62-18.43-8-37.98-8-37.98s15.99-63.3 17.99-88.62c2-25.32-.67-53.97-6.33-71.62-5.66-17.66-3.46-39.57-3.46-39.57l70.5-36.19Zm118.44 42.87c10.99 1.67 13.17 9.77 18.16 25.43 5 15.66 19.02 112.82 17.35 121.48s-15.51 39.57-20.84 46.9c-5.33 7.33-35.43 22.92-35.43 22.92l-21.13-44.26s23.65-32.31 24.65-37.98-10.99-47.64-10.99-47.64l28.23-86.86Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1437.3 340.65c-10.39 4.87-11.64 10.16-17.97 30.15-6.33 19.99-23.47 72.7-22.47 87.36 1 14.66 12.99 55.3 18.66 71.62 5.66 16.32 14.66 12.99 14.66 12.99l17.32-50.3s-8.99-20.65-8.99-25.32 12.99-54.97 14.66-61.3c1.67-6.33.46-72.87-15.86-65.2Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1495.43 272.35s4.69 29.24 4.36 39.24c-.33 9.99-6.36 30.67 11.63 36.33 17.99 5.66 35.09 2.27 41.42-8.72 6.33-10.99 1.27-19.63-.73-25.29s6.54-43.74 6.54-43.74l-63.21 2.18Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1514.48 202.43c-7.59-.03-5.58-5.39-12.43-3.68-6.85 1.7-8.78 16.56-14.13 17.93-5.35 1.37-7.25-5.7-7.25-5.7s-5.47 7.05-3.62 11.38c1.85 4.33 2.63 5.42 1.69 7.06s-7.15 3.37-6.6 8.25 4.69 9.76.76 12.06c-3.93 2.3-8.68 7.71-4.31 12.39 4.36 4.68 9.06 10.86 6.6 13.25-2.46 2.38-5.35 1.37-5.35 1.37s2.1 7.29 6.07 7.95c3.97.66 11.89 1.09 13.42 7.29 1.53 6.2-2.06 13.21 8.09 19.33 9.69 5.84 14.07 18.24 28.36 16.53 22.66-2.71 19.66-9.88 28.65-15.68 8.98-5.79 12.83-18.08 11.8-22.15-1.03-4.07 2.32-7.87 4.3-5.64 1.98 2.22 2.1 4.33 2.1 4.33s5.17-1.34 6.09-6.81c.63-3.74-6.28-7.96-3.99-10.99 2.29-3.03 12.07-11.72 7.55-24.43-4.52-12.7-14.42-12.87-14.26-22.76.16-9.9-2.65-19.34-15.42-20.93-12.76-1.6-15.41 3.94-19.61.11-4.2-3.83-4.97-8.72-11.76-7.86s-6.76 7.4-6.76 7.4Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1536.02 220.95c-5.63.77-4.15 2.5-9.61 5.76-5.46 3.26-13.12.91-18.14 3.78-5.02 2.87-3.31 6.13-6.9 9.71-3.58 3.58-14.62 12-14.98 18.09-.36 6.09 6.49 8.55 7.09 16.49.99 13.19 4.68 18.16 9.04 21.13 5.94 4.05 10.26 13.32 15.12 13.18 4.86-.14-3.64-7.53-.41-8.6 3.23-1.07 4.76 1.41 8.37.99 3.61-.42 7.15-3.37 7.64-.81.48 2.56-4.23 7.34-1.09 7.74 3.14.4 8.13-9.22 12.04-11.09 3.9-1.88 10.13-7.41 11.48-12.39 1.35-4.98.2-10.53 2.37-15.25 2.18-4.72 1.99-12.32.84-17.87-1.15-5.55-5.52-2.86-5.46-11.07.06-8.22-5.48-21.4-17.38-19.79Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1533.9 258.63 12.43-3.44.62 3.17-12.5 2.36-.55-2.09z"
      />
      <path
        d="M1537.1 261.08c.02 1.32.56 3.39 3.38 3.38 3.17 0 3.68-2.44 3.61-3.44-.13-1.91-1.99-2.79-3.5-2.59-2.06.27-3.52 1.24-3.49 2.65Zm-24.47-.5-11.83-2.94-.96 2.94 12.08 2.34.71-2.34z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1509.7 262.5c.11 1.31-.01 3.18-2.82 3.45-3.16.3-3.9-2.07-3.93-3.07-.05-1.91 1.72-2.97 3.24-2.93 2.08.07 3.4 1.14 3.52 2.55Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        d="M1526 284.93c-6.4 1.06-12.14-3.58-18.8.99-3.56 2.45-3.49 6.78-.87 7.94s4.9-5.01 10.95-4.82 14.72-1.32 18.88-.57 6.89 2.93 9.13 2.05.9-6.6-4.25-7.75-11.5 1.57-15.05 2.15Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1512.87 294.94c.44 1.72 2.62 3.2 7.94 4.47s7.84.8 10.09-.36c3.42-1.76 5.65-2.24 6.39-2.67s-.91-3.23-1.73-4.16-5.01-3.27-6.55-2.64-3.05 1.88-4.15 1.74-1.93-2.26-4.65-1.86c-2.72.39-7.85 3.47-7.33 5.48Z"
        style={{
          fill: '#eb8d05',
        }}
      />
      <path
        d="M1530.95 251.06s10.4-5.49 14.65-5.01c4.25.49 9 2.04 9 2.04l-1.52 2.37s-4.01-1.27-8.21-.09c-4.19 1.18-12.2 5.07-12.03 4.84s-1.9-4.16-1.9-4.16Zm-13.77 1.73s-10.69-4.89-14.91-4.16-7.57 3.86-7.57 3.86l1.06 2.13s3.23-2.65 7.49-1.72 12.47 4.37 12.28 4.15 1.66-4.26 1.66-4.26Z"
        style={{
          fill: '#613f2f',
        }}
      />
      <path
        d="m1557.68 257.62-.39-3.34-5.79.19s-3.65-3.07-8.54-2.75c-2.78.18-8.14.68-9.98 1.29-4.44 1.46-5.26 3.89-5.26 3.89s-2.33-1.01-4.56-.78-4.25 1.29-4.25 1.29-1.09-2.32-5.66-3.28c-1.9-.4-7.28-.29-10.06-.15-4.9.24-8.18 3.7-8.18 3.7l-5.7.22.14 4.21 4.33.35s.92 4.73 1.56 6.85c1.17 3.86 4.07 8.75 13.7 7.92 9.48-.83 11.55-9.48 12.02-11.82.29-1.42-.41-3.66-.27-5.05.05-.5 1.18-1.2 2.63-1.27 1.45-.07 2.66.47 2.77.96.29 1.37-.14 3.67.3 5.05.73 2.27 3.76 10.63 13.27 10.39 9.66-.25 12.25-6.07 12.72-9.41.31-2.2.78-6.98.78-6.98l4.43-1.45Zm-47.54 17.19c-6.02.82-9.13-.47-11.61-4.22-2.48-3.75-2.55-9.06-.79-11.57 2.21-3.15 10.52-2.95 14.8-2.34 2.52.36 5.12 1.92 5.75 6 .63 4.07-1.89 11.29-8.16 12.14Zm39.3-7.11c-2.04 4.01-4.98 5.63-11.06 5.5-6.33-.14-9.64-7.02-9.47-11.14s2.58-5.96 5.04-6.61c4.18-1.09 12.42-2.23 14.97.66 2.03 2.3 2.55 7.58.52 11.59Z"
        style={{
          fill: '#ececdb',
        }}
      />
      <path
        d="M1545.06 313.52s7.18 8.65 9.45 23.94c2.26 15.29 7.01 33.09 2.68 50.41-8.66 34.65-15.75 119.92-17.41 147.57-1.67 27.65-4.67 79.68-4.67 79.68s15.33-5.06 30.99-4.06 46.45-5.91 46.45-5.91 1.44-32.83 2.44-51.15-14.24-48.55-13.57-72.53c.67-23.99 27.23-114.18 29.89-124.84 2.67-10.66-28.05-15.92-43.22-31.4-4.26-4.35-22.82-27.42-22.82-27.42l-20.2 15.71Z"
        style={{
          fill: '#1c3628',
        }}
      />
    </svg>
  )
}

export default TeacherEnvironmentStart
